import { render, staticRenderFns } from "./jikeng.vue?vue&type=template&id=39b02e64&scoped=true"
var script = {}
import style0 from "./jikeng.vue?vue&type=style&index=0&id=39b02e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b02e64",
  null
  
)

export default component.exports